import React, { useState } from 'react';
import Filters from '../../../components/Filters';
import PageContainer from '../../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import CaseTable from '../../../components/CaseTable';

const CaseWorkflowHistory = ({ user }) => {
    const [processing, setProcessing] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [records, setRecords] = useState([]);

    const init = async () => {
        try {
            setProcessing(true);
            // const res = await getAllEscalatedCases();
            // setRecords(res?.resultObject?.data || []);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const search = async (values, closeSearchModal) => {
        try {
            // const res = await getAllCases(values);
            // if(res?.statusCode == "000") {
            //     setRecords(res?.resultObject?.data || []);
            //     closeSearchModal()
            // } else {
            //     enqueueSnackbar(res?.message || 'An error occurred', { variant: 'info' })
            // }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const exportData = async () => {
        // try {
        //     const resp = await getMyPendingBankCases({}, true)
        //     enqueueSnackbar(resp?.message || 'Your report is being processed, kindly check the reports page for progress');
        // }
        // catch(err) {
        //     enqueueSnackbar(err?.message || 'An error occurred', { variant: 'error' })
        // }
    };

    return (
        <PageContainer pageTitle="Case Workflow History" processing={processing}>
            <CaseTable
                cases={records}
                selectable={false}
                showPendingActionsBtn={false}
                showAttachBtn={false}
                // exportFunction={exportData}
                searchFunction={search}
                style={{ fontSize: '12px' }}
            />
        </PageContainer>
    );
};

export default connect(({ user }) => ({ user }))(CaseWorkflowHistory);
